/**
 * @file PRO Admin custom prints related consts.
 */

import { IMAGE_SIZE_CODE } from './image-size-codes';

/**
 * Order status types.
 *
 * @enum {{PENDING: string, CUSTOMER_INPUT: string, SHIPPED: string, CANCELED: string}}
 */
export const ORDER_STATUS = {
  CUSTOMER_INPUT: 'CUSTOMER_INPUT',
  PENDING: 'PENDING',
  SHIPPED: 'SHIPPED',
  CANCELED: 'CANCELED',
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.PENDING]: 'Pending',
  [ORDER_STATUS.CUSTOMER_INPUT]: 'Awaiting customer photos selection',
  [ORDER_STATUS.SHIPPED]: 'Fulfilled / Shipped',
  [ORDER_STATUS.CANCELED]: 'Canceled',
};

/**
 * Custom print type enum.
 *
 * @enum CUSTOM_PRINT_TYPE
 * @type {{COLLAGE: string, CUSTOM_PRINT: string, WALDOGRAM: string, CARD: string, ACCOUNT_CARD: string, PRINT_PRODUCT: string}}
 */
export const CUSTOM_PRINT_TYPE = {
  CUSTOM_PRINT: 'CUSTOM_PRINT',
  WALDOGRAM: 'WALDOGRAM',
  COLLAGE: 'COLLAGE',
  CARD: 'CARD',
  ACCOUNT_CARD: 'ACCOUNT_CARD',
  PRINT_PRODUCT: 'PRINT_PRODUCT',
};

/**
 * Custom print subtype enum.
 *
 * @enum CUSTOM_PRINT_SUBTYPE
 * @type {{FATHERS_DAY: string, GET_WELL: string, HAPPY_BIRTHDAY: string, THANK_YOU: string, THINKING_OF_YOU: string, COLLAGE: string}}
 */
export const CUSTOM_PRINT_SUBTYPE = {
  FATHERS_DAY: 'FATHERS_DAY',
  GET_WELL: 'GET_WELL',
  HAPPY_BIRTHDAY: 'HAPPY_BIRTHDAY',
  THANK_YOU: 'THANK_YOU',
  THINKING_OF_YOU: 'THINKING_OF_YOU',
  COLLAGE: 'COLLAGE',
};

/**
 * Custom print delivery type enum.
 *
 * @enum CUSTOM_PRINT_DELIVERY_TYPE
 * @type {{EXTERNAL_SHIPPING: string, ONSITE_PRINTING: string, SHIPPING: string, ONSITE_SHIPPING: string}}
 */
export const CUSTOM_PRINT_DELIVERY_TYPE = {
  ONSITE_PRINTING: 'ONSITE_PRINTING',
  ONSITE_SHIPPING: 'ONSITE_SHIPPING',
  EXTERNAL_SHIPPING: 'EXTERNAL_SHIPPING',
  SHIPPING: 'SHIPPING',
};

/**
 * CDN endpoint to use for getting Emoji images.
 * No trailing slash.
 *
 * @type {string}
 */
export const EMOJI_LIB_ENDPOINT =
  'https://d1ldwnjkukjs70.cloudfront.net/twemoji/12.0.1/svg';

export const EMOJI_LIB_ENDPOINT_BASE =
  'https://d1ldwnjkukjs70.cloudfront.net/twemoji/12.0.1';

/**
 * The image size to print for custom prints.
 *
 * @type {IMAGE_SIZE_CODE|IMAGE_SIZE_CODE}
 */
export const CUSTOM_PRINT_PRINTING_IMAGE_SIZE = IMAGE_SIZE_CODE.LARGE1X;

// We'll force the order limit to be this high until I can properly
// figure out how we'll deal with pagination & polling. As it stands, if I go to page
// 2, but polling detects there's no page 2 elements afterwards, you'll be stuck at page 2.
// TODO: Figure this out.
export const ORDER_LIMIT = 9999;
